import Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { ADD_OFFENSIVE_WORD, GET_OFFENSIVE_WORDS_LIST } from 'const';
import { makeCombinedAction } from 'utils/app/reduxHelper';
import { OffensiveWordsList } from 'interfaces';

interface OffensiveWordsReducerState {
  isLoading: boolean;
  wordsList: OffensiveWordsList;
}

const initialState = Immutable.fromJS({
  isLoading: false,
  wordsList: [],
} as OffensiveWordsReducerState);

const { PENDING, DONE } = makeCombinedAction(GET_OFFENSIVE_WORDS_LIST);

const offensiveWordsReducer = handleActions(
  {
    [PENDING]: (state) => {
      return state.set('isLoading', true);
    },
    [DONE]: (state) => {
      return state.set('isLoading', false);
    },
    [GET_OFFENSIVE_WORDS_LIST.SUCCESS]: (state, { payload }) => {
      return state.set('wordsList', Immutable.fromJS(payload));
    },
  },
  initialState
);

export default offensiveWordsReducer;
